export default __webpack_public_path__ + "static/media/file.74dbc610.png";